<app-title [title]="title"> </app-title>
<div class="loading" *ngIf="loading">
    <is-loading></is-loading>
</div>
<div class="l-main__contents">
    <div class="card-list">
        <div *ngFor="let item of navItems" [ngClass]="{ disabled: !checkAuthorization(item) }">
            @if (item.children===undefined ) {
            <div class="card-style" (click)="clickCard(item)">
                {{ item.title }}
            </div>
            } @else {
            <div class="group-style">
                {{ item.title }}
            </div>
            <div class="child-card-list">
                <div *ngFor="let child of item.children" [ngClass]="{ disabled: !checkAuthorization(child) }">
                    <div class="card-style" (click)="clickCard(child)">
                        {{ child.title }}
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>
